import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import style from './style.css'

export default class TimelineValue extends React.Component {

  constructor( props ) {
    super( props )
    this.state = { dragging : false, rel : null, pos : { x : props.x, y : 0 } }
  }

  onClick = ( evt ) => {
    evt.stopPropagation()

    const { keyframe, timeline, timeCalc } = this.props
    const x = timeCalc.timeToX( keyframe.time )

    console.log( 'in timeline value - SHOW EDITOR', this.props )
    if ( this.props.onValueClicked ) {
      this.props.onValueClicked( { x, keyframe, timeline } )
    }
  }

  componentDidUpdate( props, state ) {
    if ( this.state.dragging && !state.dragging ) {
      document.addEventListener( 'mousemove', this.onMouseMove )
      document.addEventListener( 'mouseup', this.onMouseUp )
    } else if ( !this.state.dragging && state.dragging ) {
      document.removeEventListener( 'mousemove', this.onMouseMove )
      document.removeEventListener( 'mouseup', this.onMouseUp )
    }
  }

  // calculate relative position to the mouse and set dragging=true
  onMouseDown = ( e ) => {
    // only left mouse button
    if ( e.button !== 0 ) return
    const pos = { x : this.element.offsetLeft, y : this.element.offsetTop }
    this.setState( { dragging : true, rel : { x : e.pageX - pos.x, y : e.pageY - pos.y } } )
    e.stopPropagation()
    e.preventDefault()
  }

  onMouseUp = ( e ) => {
    this.setState( { dragging : false } )
    e.stopPropagation()
    e.preventDefault()
  }

  onMouseMove = ( e ) => {
    if ( !this.state.dragging ) {
      return
    }
    const { keyframe, timeline, timeCalc } = this.props
    const x = ( e.pageX - this.state.rel.x ) + timeCalc.keyframeSize / 2
    const dx = timeCalc.discreteX( x )
    const t = timeCalc.xToTime( dx )

    if ( t != keyframe.time ) {
      if ( this.props.onTimeChangeRequest ) {
        this.props.onTimeChangeRequest( { path : timeline.path, timeline, keyframe, time : t } )
      }
    }
    e.stopPropagation()
    e.preventDefault()
  }

  render() {
    const { keyframe, timeline, timeCalc } = this.props
    const x = timeCalc.timeToX( keyframe.time )
    let xCn
    if ( timeline.attributeType == 'boolean' ) {
      xCn = keyframe.value === true ? style.boolTrue : keyframe.value === false ? style.boolFalse : null
    }
    return (
      <div ref={e => this.element = e}
        className={style.timelineValue} 
        style={{ left : x }} 
        title={keyframe.value} 
        onMouseDown={this.onMouseDown} 
        onClick={this.onClick}>
        <div className={classnames( style.timelineValueSymbol, xCn )} />
      </div>
    )
  }

}
